export default {
  Id: "GridData",
  Columns: [
    {
      Key: "Id",
      Name: "Id",
      Width: 40,
      Fixed: true,
      readOnly: true,
    },
    {
      Key: "name",
      Name: "Nome Completo",
      Width: 170,
      Fixed: true,
    },
    {
      Key: "email",
      Name: "E-mail",
      Width: 170,
    },
    {
      Key: "course",
      Name: "Curso",
      Width: 130,
    },
    {
      Key: "class",
      Name: "Turma",
      Width: 130,
    },
    {
      Key: "date",
      Name: "Data do Relatório",
      Width: 100,
    },
    {
      Key: "locale",
      Name: "Idioma (pt-BR, en ou es)",
      Width: 50,
    },
    {
      Key: "coach_email",
      Name: "Facilitador(a)/Coach (Email)",
      Width: 150,
    },
    {
      Key: "blind_participant",
      Name: "Comunicar o entrevistado? (e-mail)",
      Width: 100,
    },
  ],
  "Table::Participants": [
    {
      Id: 1,
      name: "",
      email: "",
      course: "",
      class: "",
      date: "",
      locale: "",
      coach_email: "",
      blind_participant: "sim",
    },
    {
      Id: 2,
      name: "",
      email: "",
      course: "",
      class: "",
      date: "",
      locale: "",
      coach_email: "",
      blind_participant: "sim",
    },
    {
      Id: 3,
      name: "",
      email: "",
      course: "",
      class: "",
      date: "",
      locale: "",
      coach_email: "",
      blind_participant: "sim",
    },
    {
      Id: 4,
      name: "",
      email: "",
      course: "",
      class: "",
      date: "",
      locale: "",
      coach_email: "",
      blind_participant: "sim",
    },
    {
      Id: 5,
      name: "",
      email: "",
      course: "",
      class: "",
      date: "",
      locale: "",
      coach_email: "",
      blind_participant: "sim",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/pages/Admin/Interviews/Bulk/grid.js